import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEVersionFeatureAccess, OEVersionTargetsAlphaBetaProds, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OEMediCADemyTargetType as OEMediCADemyTargetType_, implantcastTargets, OEMediCADemyStartSelectionContent} from './oe-medicademy-consts';

export const OEMediCADemyTargetType = OEMediCADemyTargetType_;

export const OEMediCADemyTargets = new OEVersionTargetsAlphaBetaProds(
    {
        [OEMediCADemyTargetType.implantcast]: implantcastTargets,
        [OEMediCADemyTargetType.ido]: [
            OETarget.surgeryIdo,
        ],
        [OEMediCADemyTargetType.ohst]: [
            OETarget.surgeryOHSTPrimaCurve,
        ]
    },
    {
        [OEMediCADemyTargetType.implantcast]: OETarget.implantcastEcoFitCup,
        [OEMediCADemyTargetType.ido]: OETarget.surgeryIdo,
        [OEMediCADemyTargetType.ohst]: OETarget.surgeryOHSTPrimaCurve,
    },
    {
    }
);

//
export const OEMediCADemyFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            implantcastTargetSelection: !isLicensing,
            idoModule: !isLicensing,
            idoTargetSelection: !isLicensing,
            ohstTargetSelection: !isLicensing,
            ohstTargetSelection: !isLicensing,
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(licensingAccess.isValid)    {
            if(OELicensingEdition.allAbove(OELicensingEdition.basic).includes(licensingAccess.edition))  {
                featureAccess.implantcastTargetSelection = true;
                featureAccess.idoModule = true;
                featureAccess.idoTargetSelection = true;
                featureAccess.ohstTargetSelection = true;
                featureAccess.ohstTargetSelection = true;
            }
        }

        return featureAccess;
    }
})(OEMediCADemyTargets);

//
export const OEMediCADemyStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OEMediCADemyTargets,
    OEMediCADemyStartSelectionContent
);